export default function useDomUtils () {
  function newNode (htmlElement: Element | null) {
    if (htmlElement === null) {
      return null;
    }
    const el = document.createElement(htmlElement.tagName);
    for (const attr of htmlElement.attributes) {
      el.setAttribute(attr.name, attr.value);
    }
    el.innerHTML = htmlElement.innerHTML;
    return el;
  }
  function createHtmlDocument (htmlString: string) {
    const parser = new DOMParser();
    return parser.parseFromString(htmlString, 'text/html');
  }
  function removeScriptElements (html = '') {
    return html?.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '');
  }
  return {
    newNode,
    createHtmlDocument,
    removeScriptElements
  };
}
